import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { StepperDialogComponent } from 'src/app/components/stepper-dialog/stepper-dialog.component';
import { Item } from 'src/app/models/item';
import { AdminService } from 'src/app/services/admin.service';
import { GeneralService } from 'src/app/services/general.service';
import { MenuService } from 'src/app/services/menu.service';
import * as XLSX from "xlsx";
import * as moment from 'moment';
import swal from 'sweetalert2';
import { alphaNumericOnly, alphaNumericHyphenSlash, alphabetWithSpaces, numericOnly } from 'src/app/functions/validation-functions';
import { LookUpService } from 'src/app/services/lookup.service';
@Component({
  selector: 'app-sales-list',
  templateUrl: './sales-list.component.html',
  styleUrls: ['./sales-list.component.css']
})
export class SalesListComponent {
  @ViewChild(StepperDialogComponent) stepperDialogComponent!: StepperDialogComponent;
  graphdata: any[] = [];
  visibleColumnData: Item[] = [];
  visibleColumnsId:any[] = [];
  graphHeader :any[]=[];
  canView:boolean = false;
  canEdit:boolean = false;
  canDelete:boolean = false;
  canCreate:boolean = false;
  viewUrl:string="";
  editUrl:string="";
  createUrl:string="";
  deleteUrl:string="";
  agentListExport:any;
  agentId:number=9999999;
  sortedIndex:number=8;
  sortOrder:string='desc';
  menuId:number = 0;
	menuUrl : string = "";
  segmentList:any = [{text:"Motor",value:"Yes"},{text:"Non-Motor",value:"No"}];
  loyaltyBonusAssignedList:any = [];
  selectedSegment:any = [];
  selectedLoyaltyBonus:any = "";
  mergedData:any = [];
  originalGraphHeader :any[]=[];
  selectedStartDate:any = moment(new Date()).add(-1, 'months').format('YYYY-MM-DD');
  selectedEndDate:any = moment(new Date()).format('YYYY-MM-DD');
  selectedMonthYear:any = moment(new Date()).format('YYYY-MM');
  maxMonthYear:any = moment(new Date()).add(3,'months').format('YYYY-MM');
  selectedDateRange:string="Past 1 Month";
  agentList:any[] = [];
  resellerList:any[] = [];
  originalResellerList:any[] = [];
  distributorList:any[] = [];
  originalAgentList:any[] = [];
  userType = this.generalService.getUserType();
  selectedAgentIds="";
  loyaltyBenifits:boolean = false
  loyaltyBenifitsDesc:string = '';
  showLoyaltyBenifitsForm= false;
  loyaltyBenifitsForm:FormGroup;
  submittedLoyaltyBenifitsForm = false;
  insuranceCompanyList:any = [];
  selectedInsuranceCompany:any = [];
  insuranceProductList:Item [] = [
    { id: "1", name: "Car", checked: true },
    { id: "2", name: "Bike", checked: true },
    { id: "3", name: "Commercial", checked: true }
    // { id: "4", name: "Health", checked: true },
    // { id: "6", name: "Travel", checked: true },
    // { id: "7", name: "Home", checked: true },
    // { id: "8", name: "Office", checked: true },
    // { id: "9", name: "Shop", checked: true },
    // { id: "10", name: "General", checked: true }
  ]; 
  selectedInsuranceProduct:any = "";  
  insurancePartnersList:Item[] = [];
  selectedInsurancePartners:any = "";
  policyType = 2;
  rebindAgentList = true;
  showPolicyList:{text:string,value:number}[] = [{text:"Both",value:2},{text:"Offline",value:1},{text:"Online",value:0}];
  isMotor = "Yes";
  policyNumber="";
  registrationNumber = "";
  addBeneficiary() {
    this.stepperDialogComponent.show = true;
  }
  showLoader:boolean = false;
  showRegistrationNo = true;
  constructor(private adminService: AdminService, private router:Router, private menuService:MenuService,private generalService: GeneralService, private fb: FormBuilder,private lookupService : LookUpService) {
    let obj = this.router.getCurrentNavigation()?.extras?.state;
    if(obj)
    {      
      this.menuId = parseInt(obj['menuId'])??0;
      this.menuUrl = obj['menuUrl'];
      this.getPermissions(this.menuId);
    }
    this.loadPolicyCategory();
    setTimeout(() => {
      this.getSalesDetails();
    }, 150);
    
    this.loadInsurancePartners();

    this.loyaltyBenifitsForm = this.fb.group({
      "isAssigned": [true, [Validators.required]],
      "loyaltyAssignDate": [moment(new Date()).format('YYYY-MM-DD'), [Validators.required]],
      "comment": [''],
      "id": ['']
    });
  }

async getSalesDetails() {
  this.showLoader = true;
  this.graphdata = [];
  this.graphHeader = [];
  let obj={
      DistributorId:'',
      ResellerId:'',
      AgentId:this.selectedAgentIds,
      StartDate: this.selectedStartDate,
      EndDate:this.selectedEndDate,
      policyType:this.policyType,
      insProductIds : this.selectedInsuranceProduct??'',
      insCompanyIds:this.selectedInsurancePartners??'',
      isMotor:this.isMotor == "Yes",
      policyNumber : this.policyNumber,
      registrationNumber : this.isMotor ? this.registrationNumber : ''
    } 
    const res = await this.adminService.GetCustomerPolicies(obj);  
    this.showLoader = false;  
    if (res != null && res.result) {
      this.graphdata = res.result.data;
      this.agentListExport =res.result.agentList;
      if(this.rebindAgentList == true){
        this.rebindAgentList  = false;
        this.agentList = res.result.agentList;
        this.originalAgentList = res.result.agentList;
        this.resellerList = this.generalService.distinct_name((res.result.agentList).map((m:any)=> {return {id: m.resellerId, name:m.resellerName, checked:1, distributorId:m.distributorId}}));
        this.originalResellerList = JSON.parse(JSON.stringify(this.resellerList));
        this.distributorList = this.generalService.distinct_name((res.result.agentList).map((m:any)=> {return {id: m.distributorId, name:m.distributorName, checked:1}}));
      }

      this.graphdata.sort( (a, b) => {
        if(this.sortOrder == 'desc')
        {
          if (a[this.sortedIndex].toString().toLowerCase() > b[this.sortedIndex].toString().toLowerCase()) {
            return -1;
          }
          if (b[this.sortedIndex].toString().toLowerCase() > a[this.sortedIndex].toString().toLowerCase()) {
              return 1;
          }          
        }
        else
        {
          if (a[this.sortedIndex].toString().toLowerCase() < b[this.sortedIndex].toString().toLowerCase()) {
            return -1;
          }
          if (b[this.sortedIndex].toString().toLowerCase() < a[this.sortedIndex].toString().toLowerCase()) {
              return 1;
          }  
        }
        return this.sortedIndex;
      });
      this.graphHeader = res.result.header;
      this.originalGraphHeader = res.result.header;
      this.visibleColumnData =  res.result.header.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_') });
      this.visibleColumnsId = this.visibleColumnData.map((m:any)=>{return m.id.toString()});
       this.getSegment();
      //  this.selectedSegment = [];
      //  this.selectedInsuranceCompany = [];
       this.selectedLoyaltyBonus = "";
    }
  }

  getSegment(){
    let header:any = this.graphHeader.map((m:any)=> {return m.key});
    let body = this.graphdata;

    this.mergedData = body.map((_:any, row:any) =>
      header.reduce((json:any, key:any, col:any) => ({
        ...json,
        [key]: body[row][col]
      }), {}));
    //this.segmentList = ([...new Set(this.mergedData.map((item:any) => item["Policy Segment"])?.filter((segment:any) => segment && segment.trim() !== ""))])?.map((m:any)=> {return {id:m, name:m,checked:(this.selectedSegment?.length > 0 ? this.selectedSegment.includes(m) : true)}});//.sort((a, b) => a.localeCompare(b));
    //this.insuranceCompanyList = ([...new Set(this.mergedData.map((item:any) => item["Company"])?.filter((company :any) => company && company.trim() !== ""))])?.map((m:any)=> {return {id:m, name:m,checked:(this.selectedInsuranceCompany?.length > 0 ? this.selectedInsuranceCompany.includes(m) : true)}});
    this.loyaltyBonusAssignedList = [...new Set(this.mergedData.map((item:any) => item["Is Loyalty Bonus Assigned"])?.filter((segment:any) => segment && segment.trim() !== ""))];
  }

  onSegmentChange(){ 
    let filteredData = this.selectedSegment?.length == 0 ? this.mergedData : this.mergedData.filter((item:any) => { return (this.selectedSegment?.length == 0 || (this.selectedSegment?.length > 0 && this.selectedSegment?.includes(item["Policy Segment"])))});
    filteredData = this.selectedInsuranceCompany?.length == 0 ? filteredData : filteredData.filter((item:any) => { return (this.selectedInsuranceCompany?.length == 0 || (this.selectedInsuranceCompany?.length > 0 && this.selectedInsuranceCompany?.includes(item["Company"])))});
    filteredData = this.selectedLoyaltyBonus == "" ? filteredData : filteredData.filter((item:any) => {return item["Is Loyalty Bonus Assigned"] == this.selectedLoyaltyBonus});
    
    // debugger;
    // let selectedSegment = [...new Set(filteredData.map((item:any) => item["Policy Segment"])?.filter((segment:any) => segment && segment.trim() !== ""))]
    // let selectedInsuranceCompany = [...new Set(filteredData.map((item:any) => item["Company"])?.filter((company :any) => company && company.trim() !== ""))]

    // let dfd =this.selectedSegment;
    // let ss = this.selectedInsuranceCompany;

    // this.segmentList = this.segmentList.map((m:any)=>{return {...m, checked:(selectedSegment?.length > 0 ? selectedSegment.includes(m.id) : true)}});
    // this.insuranceCompanyList = this.insuranceCompanyList.map((m:any)=>{return {...m, checked:(selectedInsuranceCompany?.length > 0 ? selectedInsuranceCompany.includes(m.id) : true)}});

    let header:any = [];
    if(filteredData?.length > 0){
      header = Object.keys(filteredData[0]);
    }
    else if(this.mergedData?.length > 0){
      header = Object.keys(this.mergedData[0]);
    }

    if(header?.length > 0){
      this.graphdata = filteredData.map((obj:any) => header.map((key:any) => obj[key as keyof typeof obj]));
    }
    else
    {
      this.graphdata = [];      
    }  

    if(!(this.selectedSegment.includes('Car') || this.selectedSegment.includes('Bike') || this.selectedSegment.includes('Commercial Vehicle'))){
      this.visibleColumnData = this.originalGraphHeader?.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_') && f.name != 'Registration No' });      
    }
    else
    {
      this.visibleColumnData = this.originalGraphHeader?.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_')});
    }
    this.visibleColumnsId = this.visibleColumnData.map((m:any)=>{return m.id.toString()});
    
  }
  
  onLoyaltyBonusAssignedChange(){ 
    this.onSegmentChange();   
  }

  async onActionClick(data:any)  {
    if(data)
    {
      if(data.action=="View")
      {
        this.router.navigateByUrl(this.viewUrl,{ state: { id:data.id, userId:data.id1, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
      }
      else if(data.action=="Edit")
      {        
        this.router.navigateByUrl(this.editUrl,{ state: { id:data?.extra[7], menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
      } 
      else if(data.action=="Download")
      {
        //this.router.navigateByUrl(this.editUrl,{ state: { id:data.id }});
          //this.spinner.show();
          const response = await this.adminService.DownloadPolicy(data.id?.toString());
          if (response?.isSuccess && response.result && response.result.code ==1)
          {
            const downloadLink = document.createElement('a');
            downloadLink.href = response.result.data;
            downloadLink.download = response.result.data2;
            downloadLink.target = "_blank";
            downloadLink.click();
            //this.spinner.hide();
          }
          else
          {
            //this.spinner.hide();
            swal.fire({
              position: 'center',
              imageUrl: "../../assets/alerts/warning.png",
              imageHeight: 89,
              title: "Policy document is not generated yet, please try after some time.",
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'Ok',
              cancelButtonColor: "#DF3A4D",
            }); 
          }
      } 
      else if(data.action=="LoyaltyBenifits"){
        this.showLoyaltyBenifitsForm = true; 
        this.GetLoyaltyBonus(data.id?.toString());       
      }
    }
  }
  
  onCreateBtnClick(data:any)  {
    this.router.navigateByUrl(this.createUrl,{ state: { id:data.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
  }

  async getPermissions(menuId:number)  {
    let obj = {uniqueUserId:this.generalService.getUniqueuserid(),menuId:menuId};
    let res = await this.menuService.GetMenuPermissionsByUserId(obj);
    if(res && res.isSuccess)
    {
      if(res.result.userMenus.length > 0)
      {
        res.result.userMenus.forEach((element:any) => {
          if(element.permissionName.toLowerCase() =="create")
          {
            this.canCreate = true;
            this.createUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="edit")
          {
            this.canEdit = true;
            this.editUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="view")
          {
            this.canView = true;
            this.viewUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="delete")
          {
            this.canDelete = true;
            this.deleteUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="loyaltybenifits")
          {
            this.loyaltyBenifits = true;
            this.sortedIndex = 8;
            this.loyaltyBenifitsDesc = "Loyalty Bonus"
          }
        });
      }      
    }
  }

  exportToExcel1() {
    let header:any = this.graphHeader.map((m:any)=> {return m.key});
    let body = this.graphdata;
    let excelData = body.map((_:any, row:any) =>
      header.reduce((json:any, key:any, col:any) => ({
        ...json,
        [key]: body[row][col]
      }), {}));
    excelData = excelData.filter((f:any)=> {return f.Hidden_Id2 == this.agentId});    
    excelData = excelData.map(item => {
      return Object.entries(item)
        .filter((_, index) => this.visibleColumnsId.includes(index?.toString()))
        .reduce((acc:any, [key, value]) => {
          acc[key] = value;
          return acc;
        }, {});
    });

    excelData = excelData.filter(item => {
      let expiryDate = new Date(item['Expiry Date'])//item['Expiry Date']
      let end = new Date(new Date((new Date().setMonth(new Date().getMonth() + 1))));
      end = new Date(new Date(new Date(end.setHours(23)).setMinutes(59)).setSeconds(59));
      return expiryDate >= new Date() && expiryDate < end;
    }); 

    if(excelData?.length > 0){
      const fileName = moment().format('YYYYMMDDhmmss') +"_" + (this.agentListExport.filter((f:any) => f.id == this.agentId).map((m:any) => {return m.name})[0]).replace(" ","_")+".xlsx";
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "sheet1");
      XLSX.writeFile(wb, fileName);
    }
    else
    {
      swal.fire({
        position: 'center',
        imageUrl: "../../assets/images/alerts/warning.png",
        imageHeight: 89,
        title: "No policy data available for export.",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: 'Ok',
        cancelButtonColor: "#DF3A4D",
        customClass: {
          confirmButton: "error_btn",
        }
      });
    }
  }

  async onDateRangeChange(selectedValues:any) {
    if(selectedValues?.length > 0){
      let dataArray = selectedValues.split('::');
      if(dataArray?.length > 2){
        this.selectedStartDate = dataArray[0];
        this.selectedEndDate = dataArray[1];
        this.selectedDateRange = dataArray[2];
        this.rebindAgentList = true;             
        this.selectedAgentIds = '';
        setTimeout(() => {
          this.getSalesDetails();
        }, 100);
      }
    }    
  }

  onDistributorMultiSelectChange(selectItems: Item[]): void {
    let selectedIds  = selectItems.map((item:Item) => {return item.id}).toString();
    this.resellerList = this.originalResellerList.filter((f:any)=> {return selectedIds?.split(',')?.includes(f.distributorId?.toString())});
    this.onResellerMultiSelectChange(this.resellerList);
  }
  
  onResellerMultiSelectChange(selectItems: Item[]): void {
    let selectedIds  = selectItems.map((item:Item) => {return item.id}).toString();
    this.agentList = this.originalAgentList.filter((f:any)=> {return selectedIds?.split(',')?.includes(f.resellerId?.toString())});
    this.onAgentMultiSelectChange(this.agentList);
  }

  onAgentMultiSelectChange(selectItems: Item[]): void {
    this.selectedAgentIds = selectItems.map((item:Item) => {return item.id}).toString();
    this.getSalesDetails();
  }
  
  onSegmentMultiSelectChange(selectItems: Item[]): void {
    // this.selectedSegment = selectItems.map((item:Item) => {return item.id});
    // this.onSegmentChange();
    this.selectedInsuranceProduct = selectItems.map((item:Item) => {return item.id})?.toString();
    // this.rebindAgentList = true; 
    // this.getSalesDetails();
  }
  
  onInsuranceCompanyMultiSelectChange(selectItems: Item[]): void {
    //this.selectedInsuranceCompany = selectItems.map((item:Item) => {return item.id});
    //this.onSegmentChange();
    this.selectedInsurancePartners = selectItems.map((item:Item) => {return item.id})?.toString();
    // this.rebindAgentList = true; 
    // this.getSalesDetails();
  }

  get loyaltyBenifitsFormControl() {
    return this.loyaltyBenifitsForm.controls;
  }

  numericOnly(event:any): boolean {
    return numericOnly(event);
  }
  
  async GetLoyaltyBonus(id:any){
    const response = await this.adminService.GetLoyaltyBonus(id);
    if (response?.isSuccess && response?.result)
    {
      this.loyaltyBenifitsForm?.patchValue(response.result);
      this.loyaltyBenifitsForm?.get("id")?.setValue(id);
    }    
    else
    {
      swal.fire({
        position: 'center',
        imageUrl: "../../assets/alerts/warning.png",
        imageHeight: 89,
        title: response?.message??"Something went wrong!",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: 'Ok',
        cancelButtonColor: "#DF3A4D",
      }); 
    }
  }

  async updateLoyaltyBenifits(){
    const res = await this.adminService.UpdateLoyaltyBonusData(this.loyaltyBenifitsForm?.value);
    swal.fire({
        position: 'center',
        icon: res?.result?.code == 1 ? 'success' : 'error',
        //imageUrl: res.result.code == 1 ? "../../assets/alerts/success.png" : "../../assets/alerts/warning.png",
        title: res.result?.message??"Someting went wrong!",
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'Ok',
        confirmButtonColor: res?.result?.code == 1 ? "#0DB561" : "#DF3A4D"
      }).then(() => {
        if(res.result.code == 1){
          window.location.href = window.location.href;
        }
      }); 
  }

  async loadInsurancePartners()
  {
    let response = await this.lookupService.GetInsurancePartnersList();
    if (response?.isSuccess && response?.result) {
      this.insurancePartnersList = response.result.map((m:any)=> {return {name:m.insuranceName,value:m.insuranceId,id:m.insuranceId,checked:true}});
    }
  }

  applyFilter(){
    debugger;
    if((this.policyNumber == '' || (this.policyNumber != '' && this.policyNumber.length >= 6)) && (this.registrationNumber == '' || (this.registrationNumber != '' && this.registrationNumber.length >= 6))){
      this.rebindAgentList = true;
      this.getSalesDetails();
    }
  }

  monthYearChange(selectedValue:any){
    //alert(selectedValue); 
    this.selectedMonthYear = selectedValue//this.parseDate(selectedValue);
    this.selectedEndDate = this.parseDate(selectedValue);
    // //this.selectedDateRange = dataArray[2];
    this.rebindAgentList = true;             
    this.selectedAgentIds = '';
    setTimeout(() => {
      this.getSalesDetails();
    }, 100);
  }

  parseDate(input:any) {
    // Normalize separators and spaces
    const normalized = input
      .trim()
      .replace(/[.,/\\_\s]+/g, '-');

    // Common world date formats
    const formats = [
      // Year first
      'YYYY-M-D',
      'YYYY-MM-DD',
      'YYYY-M',
      'YYYY-MM',

      // Day first
      'D-M-YYYY',
      'DD-MM-YYYY',
      'D-M-YY',
      'DD-MM-YY',

      // Month first
      'M-D-YYYY',
      'MM-DD-YYYY',
      'M-D-YY',
      'MM-DD-YY',

      // Text month formats
      'D-MMM-YYYY',
      'DD-MMM-YYYY',
      'D-MMMM-YYYY',
      'DD-MMMM-YYYY',

      'MMM-D-YYYY',
      'MMMM-D-YYYY',

      'YYYY-MMM-D',
      'YYYY-MMMM-D',

      // Compact ISO-like
      'YYYYMMDD',
      'DDMMYYYY',
      'MMDDYYYY'
    ];

    const date = moment(normalized, formats, true);

    return date.isValid()
      ? date.format('YYYY-MM-DD')
      : '';
  }

  segmentChange(){
    // this.insuranceForm.get('planName')?.setValue("");
    // this.insuranceForm.get("vehicleType")?.setValue("");
    setTimeout(() => {
      this.loadPolicyCategory();
    }, 100);
  }

  loadPolicyCategory(){
    if(this.isMotor == "Yes"){
      this.showRegistrationNo = true;
      this.insuranceProductList = [
      { id: "1", name: "Car", checked: true },
      { id: "2", name: "Bike", checked: true },
      { id: "3", name: "Commercial", checked: true }];
    }
    else
    {
      this.showRegistrationNo = false;
      this.registrationNumber = "";
      this.insuranceProductList =  [
      { id: "4", name: "Health", checked: true },
      { id: "6", name: "Travel", checked: true },
      { id: "7", name: "Home", checked: true },
      { id: "8", name: "Office", checked: true },
      { id: "9", name: "Shop", checked: true },
      { id: "10", name: "General", checked: true }];
    }

    this.onSegmentMultiSelectChange(this.insuranceProductList);
  }
}
